var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#2B1E68"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.1667 20.2142C28.4164 20.7268 29.0866 21.213 29.6518 21.3182L33.0031 21.8701C35.1453 22.225 35.6447 23.7758 34.107 25.3266L31.4917 27.9419C31.058 28.3756 30.8083 29.2298 30.9529 29.8475L31.702 33.0806C32.2934 35.6302 30.9266 36.629 28.6792 35.2885L25.5382 33.4223C24.9731 33.0806 24.0269 33.0806 23.4617 33.4223L20.3207 35.2885C18.0734 36.6158 16.7066 35.6302 17.298 33.0806L18.0471 29.8475C18.1917 29.243 17.942 28.3887 17.5083 27.9419L14.893 25.3266C13.3553 23.7889 13.8547 22.2381 15.9969 21.8701L19.3482 21.3182C19.9133 21.2262 20.5836 20.7268 20.8333 20.2142L22.6864 16.5081C23.672 14.4973 25.3017 14.4973 26.3136 16.5081L28.1667 20.2142Z",
    stroke: "#836AFF",
    strokeWidth: 1.97135,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.0c28ff59.svg";
export { ForwardRef as ReactComponent };